import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';

/**
 * Watches the Formik `location` field and triggers a callback when it changes.
 * Also triggers on initial mount if the location is already set (e.g. when
 * editing an existing new hire request). Must be rendered inside a Formik
 * context whose values include a `location` field.
 */
const NewHireLocationWatcher = ({
  onLocationChange,
}: {
  onLocationChange: (location: string) => void;
}) => {
  const { values } = useFormikContext<NewHireRequestFormValues>();
  const prevLocation = useRef<string | null>(null);

  useEffect(() => {
    if (values.location !== prevLocation.current) {
      prevLocation.current = values.location;
      if (values.location) {
        onLocationChange(values.location);
      }
    }
  }, [values.location, onLocationChange]);

  return null;
};

export default NewHireLocationWatcher;
